// ログインフォームとパスワード再設定フォームの表示切替
document.addEventListener('DOMContentLoaded', function() {
  // 再設定フォームとログイン/登録フォームを取得
  const recoverForm = document.getElementById('RecoverPasswordForm');
  const loginAndRegister = document.getElementById('LoginAndRegister');
  // 「パスワードをお忘れの方はこちら」押下時
  document.querySelectorAll('a[href="#recover"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      // 全体を表示状態に戻す
      document.querySelector('.customer.login').style.display = 'block';
      // 再設定フォームを表示
      recoverForm.style.display = 'block';
      recoverForm.classList.add('active');
      // ログイン＆新規会員登録フォームを非表示
      loginAndRegister.style.display = 'none';

      // スクロール位置をトップに戻す
      window.scrollTo({ top: 0, behavior: 'instant' });
    });
  });
  // 「キャンセル」押下時
  document.querySelectorAll('a[href="#login"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      // 全体を表示状態に戻す
      document.querySelector('.customer.login').style.display = 'block';
      // 再設定フォームを非表示
      recoverForm.style.display = 'none';
      recoverForm.classList.remove('active');
      // ログイン＆新規会員登録フォームを表示
      loginAndRegister.style.display = 'flex';
    });
  });
});
